module.exports = () => {
  return {
    app_id: {
      label: '应用AppID',
      type: 'input',
      value: '',
      rules: [
        { required: true, message: '请输入应用AppID！', trigger: ['blur', 'change'] },
      ],
    },
    app_name: {
      label: '应用名称',
      type: 'input',
      value: '',
      rules: [
        { required: true, message: '请输入应用名称！', trigger: ['blur', 'change'] },
      ],
    },
    secret: {
      label: '应用secret',
      type: 'input',
      value: '',
      rules: [
        { required: true, message: '请输入应用secret！', trigger: ['blur', 'change'] },
      ],
    },
    rebate: {
      label: '返点',
      type: 'input-number',
      value: 0,
      props: {
        min: 0,
        precision: 4,
      },
      rules: [
        { required: true, message: '请输入返点！', trigger: ['blur', 'change'] },
      ],
    },
  };
};
